// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ShareEntityButtonStyles } from "@insite/content-library/Components/ShareEntityButton";
import { IconWrapper } from "@insite/mobius/Icon";
import Mail from "@insite/mobius/Icons/Mail";
import Printer from "@insite/mobius/Icons/Printer";
import Save from "@insite/mobius/Icons/Save";
import Trash2 from "@insite/mobius/Icons/Trash2";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Check from "@steiner/XDL/Icons/Check";
import Plus from "@steiner/XDL/Icons/Plus";
import { color, createLinkIconStyles } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

interface MyAccountDetailsStyles {
    myAccountDetailsActions?: {
        saveOrderLink?: LinkPresentationProps;
        placeOrderLink?: LinkPresentationProps;
        acceptLink?: LinkPresentationProps;
        addAllToListClickable?: LinkPresentationProps;
        removeAllLink?: LinkPresentationProps;
        printLink?: LinkPresentationProps;
        emailLink?: ShareEntityButtonStyles;
    };
}

const myAccountDetailsStyles: MyAccountDetailsStyles = {
    myAccountDetailsActions: {
        saveOrderLink: {
            ...createLinkIconStyles({ icon: Save }),
        },
        placeOrderLink: {
            ...createLinkIconStyles({ icon: Save }),
        },
        acceptLink: {
            ...createLinkIconStyles({ icon: Check }),
        },
        addAllToListClickable: {
            ...createLinkIconStyles({ icon: Plus }),
        },
        removeAllLink: {
            ...createLinkIconStyles({ icon: Trash2 }),
        },
        printLink: {
            ...createLinkIconStyles({ icon: Printer }),
        },
        emailLink: {
            button: {
                variant: "link" as any,
                mergeCss: true,
                icon: {
                    src: Mail,
                    position: "left",
                },
                sizeVariant: "small",
                color: "primary",
            },
        },
    },
};

export default myAccountDetailsStyles;
